import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=e1852e36&lang=pug&"
import script from "./Paginator.vue?vue&type=script&lang=ts&"
export * from "./Paginator.vue?vue&type=script&lang=ts&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=e1852e36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports